export default "__VITE_ASSET__cc3246ff__"